import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfigurationService, UserDetailDto } from '../configuration.service';

@Component({
  selector: 'app-user-edit-dialog',
  templateUrl: './user-edit-dialog.component.html',
  styleUrls: ['../configuration-form.css'],
})
export class UserEditDialogComponent {
  form: FormGroup;
  submitting = false;
  error = '';

  constructor(
    private fb: FormBuilder,
    private api: ConfigurationService,
    private dialogRef: MatDialogRef<UserEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UserDetailDto
  ) {
    this.form = this.fb.group({
      displayName:  [data.displayName || '', Validators.maxLength(120)],
      userName:     [data.userName || '', Validators.maxLength(64)],
      emailAddress: [data.emailAddress, [Validators.required, Validators.email, Validators.maxLength(256)]],
      canLogin:     [data.canLogin],
    });
  }

  submit(): void {
    if (this.form.invalid || this.submitting) return;
    this.submitting = true;
    this.error = '';
    const v = this.form.value;
    this.api.updateUser(this.data.id, {
      displayName:  v.displayName || null,
      userName:     v.userName || null,
      emailAddress: v.emailAddress,
      canLogin:     v.canLogin,
    }).subscribe({
      next: () => this.dialogRef.close({ updated: true }),
      error: err => {
        this.submitting = false;
        this.error = err.status === 403
          ? "You don't have permission to edit users."
          : (err.error?.message || `Couldn't save changes (error ${err.status || 'network'}).`);
      }
    });
  }

  cancel(): void {
    if (this.form.dirty && !confirm('Discard unsaved changes?')) return;
    this.dialogRef.close();
  }
}
